import React from "react";
import {
    List,
    Typography,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";


type TermsProps = {
    action?: Function;
}

export default function TermsAndConditions({ action }: TermsProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <MainScreen lower={false} back={true} action={action}>
            <List>

                <Typography variant="h2">
                    {t("terms.title.Introduction")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Introduction")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Content")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Content")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Register")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Register")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Notifications")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Notifications")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Update")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Update")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Fraud")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Fraud")}
                </Typography>

                <Typography variant="h2">
                    {t("terms.title.Questions")}
                </Typography>
                <Typography variant="h5">
                    {t("terms.text.Questions")}
                </Typography>

            </List>

        </MainScreen>

    );
}
